/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsContainerProviders extends models.FilterOptionsCloudProvider {
    getFixupPrototypeFunction() { return FilterOptionsContainerProviders.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsContainerProviders>): FilterOptionsContainerProviders {
        let obj = Object.assign(new FilterOptionsContainerProviders(), model);
        FilterOptionsContainerProviders.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsContainerProviders>): FilterOptionsContainerProviders {
        if (!model) return null;
        return FilterOptionsContainerProviders.newInstance(<FilterOptionsContainerProviders> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsContainerProviders) {
        if (!obj) return;

        models.FilterOptionsContainerProviders.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsContainerProviders): boolean {
        if (models.FilterOptionsCloudProvider.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsContainerProviders.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
